import { render, staticRenderFns } from "./ActionCenterModal.vue?vue&type=template&id=3bc488e2"
import script from "./ActionCenterModal.vue?vue&type=script&lang=js"
export * from "./ActionCenterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports